import type {InventoryPresenter} from '../inventory.presenter';
import KpSearchInSearchContext from '../../search/kp-search/KpSearchInSearchContext.svelte';

export class InventoriesController {
    public static controllerName = 'InventoriesCtrl';

    public kpSearchInSearchContext = KpSearchInSearchContext;

    /*@ngInject*/
    constructor(private inventoryPresenter: InventoryPresenter) {
    }

    public async createInventory() {
        await this.inventoryPresenter.createInventory();
    }
}
